import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { SessionService } from './core/services/session.service';
import { isTrustedModuleMessage, ModuleSession, parseModuleSession } from './core/services/module-session';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'frontend-militar';
  hasInited = false;

  private readonly receiveSession = (event: MessageEvent): void => {
    if (!isTrustedModuleMessage(event, window.parent, environment.URL_SGPREV)) return;
    if (event.data?.sessionExpired) { this.zone.run(() => this.clearSession()); return; }
    const session = parseModuleSession(event.data?.token, event.data?.guardiao);
    if (session) {
      this.zone.run(() => this.applySession(session, typeof event.data?.identity === 'string' ? event.data.identity : null));
    }
  };

  constructor(private session: SessionService, private zone: NgZone) {}

  ngOnInit(): void {
    window.addEventListener('message', this.receiveSession);
    const url = new URL(window.location.href);
    const hasParameters = url.searchParams.has('token') || url.searchParams.has('guardiao');
    const session = hasParameters
      ? parseModuleSession(url.searchParams.get('token'), url.searchParams.get('guardiao'))
      : parseModuleSession(sessionStorage.getItem('token'), sessionStorage.getItem('guardiao'));

    const identity = hasParameters ? url.searchParams.get('identity') : sessionStorage.getItem('sgprevIdentity');
    if (hasParameters) {
      url.searchParams.delete('token');
      url.searchParams.delete('guardiao');
      url.searchParams.delete('identity');
      window.history.replaceState(window.history.state, '', url.toString());
    }
    // A sessão vale com token + guardião (como antes de 21/09); a identidade assinada é opcional
    // e só existe quando o legado publicado a emitir.
    if (session) {
      this.applySession(session, identity);
    } else {
      this.clearSession();
    }
  }

  private applySession(session: ModuleSession, identity: string | null): void {
    if (identity) sessionStorage.setItem('sgprevIdentity', identity);
    else sessionStorage.removeItem('sgprevIdentity');
    this.session.setSession(session.token, 'MILITAR', session.guardiao);
    this.hasInited = true;
  }

  private clearSession(): void {
    this.session.setSession('', '', null);
    ['token', 'guardiao', 'tipoBeneficiario', 'sgprevIdentity'].forEach(key => sessionStorage.removeItem(key));
    this.hasInited = false;
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.receiveSession);
  }
}
